import React, { Component } from 'react'
import * as R from 'ramda'
import i18n from 'i18next'

import Modal from '../../../../../UniformComponents/Modal'
import ModalHeader from '../../../../../UniformComponents/ModalHeader'
import Button from '../../../../../UniformComponents/Button'
import FilterPanel from './FilterPanel'
import { getOptionTitle, getQuestionTitle } from '../../../../../utils/QuestionHelper'

import './style.scss'

class FilterModal extends Component {
    dateOptions = () => {
        const options = [
            {
                title: 'Start date',
                pageQuestions: [{
                    label: '',
                    id: 'startDate',
                    options: [
                        {
                            id: 'startDate',
                            label: 'Start date',
                            value: 'startDate',
                        },
                    ],
                }],
            },
            {
                title: 'End date',
                pageQuestions: [{
                    label: '',
                    id: 'endDate',
                    options: [
                        {
                            id: 'endDate',
                            label: 'End date',
                            value: 'endDate',
                        },
                    ],
                }],
            },
        ]

        return {
            type: 'date',
            options,
        }
    }

    campaignOptions = () => {
        const { reportStore } = this.props
        const { campaignList } = reportStore

        const options = Object.entries(campaignList).map(([type, campaigns]) => ({
            title: type,
            pageQuestions: [{
                label: type,
                id: type,
                options: campaigns,
            }],
        }))

        return {
            type: 'questions',
            options,
        }
    }

    getOpenEndedOptions = () => {
        const { reportStore } = this.props
        const { locale, appStore } = reportStore
        const { survey } = appStore
        const { defaultLocale } = survey.metadata

        const options = reportStore.reportPages.map((page, pageIndex) => {
            const { title, questions } = page
            const pageQuestions = questions
                .filter(({ questionTypeCode }) => ['TA', 'TX', 'TL', 'UV', 'DT'].includes(questionTypeCode))
                .map((question) => {
                    const { questionTypeCode, metadata } = question
                    const { initialLocale } = metadata

                    const questionTitleObj = getQuestionTitle({
                        content: question.content.shortTitle,
                        formContent: R.pathOr(null, ['formContent', 'shortTitle'])(question),
                        locale,
                        defaultLocale,
                        initialLocale,
                    })
                    const questionTitle = R.pathOr(questionTitleObj, ['text'], questionTitleObj)
                    const questionOptions = reportStore.openEnded.get(question.id)
                    let options = []

                    if (['TL', 'UV'].includes(questionTypeCode)) {
                        options = Object.entries(questionOptions).flatMap(([k, { responses }]) => (
                            responses.map(({ label, surveyDataIds }) => ({
                                id: `${question.id}_${k.toLowerCase()}_${label}`,
                                label,
                                surveyDataIds,
                            }))
                        ))
                    } else {
                        options = questionOptions.map(({ label, surveyDataIds }) => ({
                            id: `${question.id}_${label}`,
                            label,
                            surveyDataIds,
                        }))
                    }

                    // let options = (question.optionSet || { options: [] }).options
                    //     .map((o) => ({
                    //         id: o.id,
                    //         label: getOptionTitle({
                    //             langs: o.langs,
                    //             locale,
                    //             defaultLocale,
                    //             initialLocale,
                    //         }),
                    //         setYId: o.id,
                    //     }))

                    // if (['SG', 'TB', 'RT'].includes(questionTypeCode)) {
                    //     const setXOptions = (question.optionSetX || { options: [] }).options
                    //         .map((o) => ({
                    //             label: getOptionTitle({
                    //                 langs: o.langs,
                    //                 locale,
                    //                 defaultLocale,
                    //                 initialLocale,
                    //             }),
                    //             setXId: o.id,
                    //         }))

                    //     options = options.reduce((list, { label, setYId }) => (
                    //         list.concat(
                    //             setXOptions.reduce((listX, optionX) => {
                    //                 listX.push({
                    //                     id: `${setYId}|${optionX.setXId}`,
                    //                     label: `${label} - ${optionX.label}`,
                    //                     setYId,
                    //                     setXId: optionX.setXId,
                    //                 })
                    //                 return listX
                    //             }, []),
                    //         )
                    //     ), [])
                    // }
                    return {
                        label: questionTitle,
                        id: question.id,
                        questionTypeCode,
                        options,
                    }
                })

            return {
                title: `Page ${pageIndex + 1}`,
                description: title,
                pageQuestions,
            }
        })

        return {
            type: 'questions',
            options,
        }
    }

    getPageOptions = () => {
        const { reportStore } = this.props
        const { locale, appStore } = reportStore
        const { survey } = appStore
        const { defaultLocale } = survey.metadata

        const options = reportStore.reportPages.map((page, pageIndex) => {
            const { title, questions } = page
            const pageQuestions = questions
                .filter(({ questionTypeCode }) => !['ST', 'TA', 'TX', 'TL', 'UV', 'I', 'OD', 'DT'].includes(questionTypeCode))
                .map((question) => {
                    const { questionTypeCode, metadata } = question
                    const { initialLocale } = metadata

                    const questionTitleObj = getQuestionTitle({
                        content: question.content.shortTitle,
                        formContent: R.pathOr(null, ['formContent', 'shortTitle'])(question),
                        locale,
                        defaultLocale,
                        initialLocale,
                    })
                    const questionTitle = R.pathOr(questionTitleObj, ['text'], questionTitleObj)

                    let options = (question.optionSet || question.optionSetY).options
                        .map((o) => {
                            const label = getOptionTitle({
                                langs: o.langs,
                                locale,
                                defaultLocale,
                                initialLocale,
                            })
                            return {
                                id: `${question.id}_${o.id}`,
                                label: R.pathOr(label, ['text'], label),
                                setYId: o.id,
                            }
                        })

                    if (['SG', 'TB', 'RT'].includes(questionTypeCode)) {
                        const setXOptions = (question.optionSetX || { options: [] }).options
                            .map((o) => {
                                const label = getOptionTitle({
                                    langs: o.langs,
                                    locale,
                                    defaultLocale,
                                    initialLocale,
                                })
                                return {
                                    label: R.pathOr(label, ['text'], label),
                                    setXId: o.id,
                                }
                            })

                        options = options.reduce((list, { label, setYId }) => (
                            list.concat(
                                setXOptions.reduce((listX, optionX) => {
                                    listX.push({
                                        id: `${question.id}_${setYId}_${optionX.setXId}`,
                                        label: `${label} - ${optionX.label}`,
                                        setYId,
                                        setXId: optionX.setXId,
                                    })
                                    return listX
                                }, []),
                            )
                        ), [])
                    }
                    return {
                        label: questionTitle,
                        id: question.id,
                        questionTypeCode,
                        options,
                    }
                })

            return {
                title: `Page ${pageIndex + 1}`,
                description: title,
                pageQuestions,
            }
        })

        return {
            type: 'questions',
            options,
        }
    }

    addRuleOption = (id, option) => {
        console.log('addRuleOption', id, option)
    }

    render() {
        const {
            show, reportStore, filters, onSave, onClose,
        } = this.props
        return (
            <Modal show={show} onClose={onClose} cssClass="reportFilter">
                <ModalHeader>
                    <h3>{i18n.t('report.filter.h3')}</h3>
                    <h4>{i18n.t('report.filter.h4')}</h4>
                </ModalHeader>
                <div className="body">
                    <FilterPanel
                        title={i18n.t('report.filter.response.title')}
                        description={i18n.t('report.filter.response.description')}
                        optionTitle={i18n.t('report.filter.response.optionTitle')}
                        optionDescription={i18n.t('report.filter.response.optionDescription')}
                        filterTitle={i18n.t('report.filter.response.filterTitle')}
                        filterDescription={i18n.t('report.filter.response.filterDescription')}
                        reportStore={reportStore}
                        filterKey="question"
                        ruleGroup={filters}
                        getFilterOptions={this.getPageOptions}
                        addRuleOption={this.addRuleOption}
                        onSave={onSave}
                    />
                    {process.env.USE_VERBATIM_FILTER && (
                        <FilterPanel
                            title={i18n.t('report.filter.verbatim.title')}
                            description={i18n.t('report.filter.verbatim.description')}
                            reportStore={reportStore}
                            filterKey="openEnded"
                            getFilterOptions={this.getOpenEndedOptions}
                            ruleGroup={filters}
                            addRuleOption={this.addRuleOption}
                            onSave={onSave}
                        />
                    )}
                    <FilterPanel
                        title={i18n.t('report.filter.campaign.title')}
                        description={i18n.t('report.filter.campaign.description')}
                        optionTitle={i18n.t('report.filter.campaign.optionTitle')}
                        optionDescription={i18n.t('report.filter.campaign.optionDescription')}
                        filterTitle={i18n.t('report.filter.campaign.filterTitle')}
                        filterDescription={i18n.t('report.filter.campaign.filterDescription')}
                        reportStore={reportStore}
                        filterKey="campaign"
                        getFilterOptions={this.campaignOptions}
                        ruleGroup={filters}
                        addRuleOption={this.addRuleOption}
                        onSave={onSave}
                    />
                    <FilterPanel
                        title={i18n.t('report.filter.responseDate.title')}
                        description={i18n.t('report.filter.responseDate.description')}
                        optionTitle={i18n.t('report.filter.responseDate.optionTitle')}
                        optionDescription={i18n.t('report.filter.responseDate.optionDescription')}
                        filterTitle={i18n.t('report.filter.responseDate.filterTitle')}
                        filterDescription={i18n.t('report.filter.responseDate.filterDescription')}
                        reportStore={reportStore}
                        filterKey="responseDate"
                        getFilterOptions={this.dateOptions}
                        ruleGroup={filters}
                        addRuleOption={this.addRuleOption}
                        onSave={onSave}
                    />
                    <Button
                        label={i18n.t('close')}
                        cssClass="regular tertiary"
                        onClick={onClose}
                    />
                </div>
            </Modal>
        )
    }
}

export default FilterModal
